<template>
    <div class="pochi-checkbox">
        <!-- <input
            class="pochi-checkbox__checkbox"
            type="checkbox"
            v-model="inputedValue"
            v-bind="$attrs"
        /> -->
        <ToggleButton
            v-model="inputedValue"
            :sync="true"
            :color="{checked: '#02AD90', unchecked: '#3B4043'}"
            v-bind="sizes"
            xxlabels="{checked: '昇順', unchecked: '降順'}"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        // TODO: size: color共通デザインmixin化
        // color: {
        //     type: String,
        //     default: 'normal',
        //     validator: function (value) {
        //         return colors.indexOf(value ?? 'normal') !== -1;
        //     },
        // },
        small: {
            type: Boolean,
            default: false,
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        xLarge: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        inputedValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
        sizes: function() {
            switch (true) {
                case this.small:
                    return { width: 40, height: 25 };
                case this.xSmall:
                    return { width: 30, height: 20 };
                case this.large:
                case this.xLarge:
                default:
                    return { width: 60, height: 30 };
            }
        },
    },
}
</script>

<style lang="sass">
    .pochi-checkbox
    // TODO: デザイン
</style>
